export const VideoSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    className="about-icon video-icon"
  >
    <path d="M9 6.886v10.228L16.5 12zm1 1.893L14.725 12 10 15.221zM1 3v18h22V3zm21 17H2V4h20z" />
    <path fill="none" d="M0 0h24v24H0z" />
  </svg>
);

export const FinanceLessonsSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 512 512"
    id="Layer_1"
    version="1.1"
    xmlSpace="preserve"
    className="about-icon finance-lesson-icon"
  >
    <g>
      <path d="M443.7,96.9H229.4c-2-38.7-34.2-69.6-73.4-69.6c-10.5,0-20.7,2.2-30.2,6.5c-25.1,11.3-41.7,35.8-43.2,63.1   H68.3c-17.6,0-31.9,14.3-31.9,31.9v197.7v52.9c0,17.6,14.3,31.9,31.9,31.9h157.1l-8.9,59.3h-15.1c-3.9,0-7,3.1-7,7s3.1,7,7,7h21.2   h67h21.2c3.9,0,7-3.1,7-7s-3.1-7-7-7h-15.1l-8.9-59.3h157.1c17.6,0,31.9-14.3,31.9-31.9V139.8v-11   C475.6,111.3,461.3,96.9,443.7,96.9z M131.5,46.6c7.7-3.5,15.9-5.2,24.5-5.2c32.8,0,59.5,26.7,59.5,59.5c0,1,0,1.9-0.1,2.8   c-1.4,31.8-27.6,56.7-59.4,56.7c-31.9,0-58-24.9-59.4-56.7c0-0.1,0-0.1,0-0.2c0-0.2,0-0.4,0-0.6c0-0.7,0-1.3,0-2   C96.5,77.5,110.2,56.2,131.5,46.6z M68.3,110.9h14.9c0,0.1,0,0.2,0.1,0.3c0.1,0.5,0.2,1,0.2,1.5c0.1,0.6,0.2,1.3,0.3,1.9   c0.1,0.5,0.2,1,0.3,1.5c0.1,0.6,0.3,1.2,0.4,1.9c0.1,0.5,0.3,1,0.4,1.5c0.2,0.6,0.3,1.2,0.5,1.8c0.1,0.5,0.3,1,0.5,1.5   c0.2,0.6,0.4,1.2,0.6,1.8c0.2,0.5,0.3,1,0.5,1.5c0.2,0.6,0.4,1.2,0.7,1.7c0.2,0.5,0.4,1,0.6,1.4c0.2,0.6,0.5,1.1,0.7,1.7   c0.2,0.5,0.4,0.9,0.6,1.4c0.3,0.6,0.5,1.1,0.8,1.7c0.2,0.4,0.5,0.9,0.7,1.3c0.3,0.6,0.6,1.1,0.9,1.6c0.2,0.4,0.5,0.9,0.7,1.3   c0.3,0.5,0.7,1.1,1,1.6c0.3,0.4,0.5,0.8,0.8,1.2c0.4,0.5,0.7,1.1,1.1,1.6c0.3,0.4,0.5,0.8,0.8,1.1c0.4,0.6,0.8,1.1,1.2,1.6   c0.3,0.3,0.5,0.7,0.8,1c0.5,0.6,0.9,1.2,1.4,1.7c0.2,0.3,0.5,0.6,0.7,0.8c0.6,0.7,1.3,1.4,2,2.1c0.1,0.1,0.2,0.2,0.3,0.3   c0.8,0.8,1.6,1.6,2.4,2.4c0.2,0.2,0.4,0.3,0.5,0.5c0.6,0.6,1.3,1.2,1.9,1.8c0.3,0.3,0.6,0.5,0.9,0.7c0.6,0.5,1.1,0.9,1.7,1.4   c0.3,0.3,0.7,0.5,1,0.8c0.5,0.4,1.1,0.8,1.6,1.2c0.4,0.3,0.8,0.5,1.1,0.8c0.5,0.4,1.1,0.7,1.6,1.1c0.4,0.3,0.8,0.5,1.2,0.8   c0.5,0.3,1.1,0.7,1.6,1c0.4,0.3,0.8,0.5,1.3,0.7c0.5,0.3,1.1,0.6,1.6,0.9c0.4,0.2,0.9,0.5,1.3,0.7c0.6,0.3,1.1,0.6,1.7,0.8   c0.5,0.2,0.9,0.4,1.4,0.6c0.6,0.3,1.1,0.5,1.7,0.7c0.5,0.2,0.9,0.4,1.4,0.6c0.6,0.2,1.2,0.4,1.7,0.7c0.5,0.2,1,0.3,1.4,0.5   c0.6,0.2,1.2,0.4,1.8,0.6c0.5,0.2,1,0.3,1.5,0.4c0.6,0.2,1.2,0.3,1.8,0.5c0.5,0.1,1,0.3,1.5,0.4c0.6,0.2,1.3,0.3,1.9,0.4   c0.5,0.1,1,0.2,1.5,0.3c0.7,0.1,1.3,0.2,2,0.3c0.5,0.1,1,0.2,1.5,0.2c0.7,0.1,1.4,0.2,2.1,0.3c0.5,0.1,0.9,0.1,1.4,0.2   c0.8,0.1,1.6,0.1,2.4,0.2c0.4,0,0.8,0.1,1.2,0.1c1.2,0.1,2.4,0.1,3.6,0.1c1.2,0,2.4,0,3.6-0.1c0.4,0,0.8-0.1,1.2-0.1   c0.8,0,1.6-0.1,2.3-0.2c0.5,0,0.9-0.1,1.4-0.2c0.7-0.1,1.4-0.2,2.1-0.3c0.5-0.1,1-0.2,1.5-0.2c0.7-0.1,1.3-0.2,2-0.3   c0.5-0.1,1-0.2,1.5-0.3c0.6-0.1,1.2-0.3,1.9-0.4c0.5-0.1,1-0.3,1.5-0.4c0.6-0.2,1.2-0.3,1.8-0.5c0.5-0.1,1-0.3,1.5-0.5   c0.6-0.2,1.1-0.4,1.7-0.6c0.5-0.2,1-0.4,1.5-0.5c0.6-0.2,1.1-0.4,1.7-0.6c0.5-0.2,1-0.4,1.5-0.6c0.5-0.2,1.1-0.5,1.6-0.7   c0.5-0.2,1-0.5,1.5-0.7c0.5-0.2,1-0.5,1.5-0.7c0.5-0.3,1-0.5,1.5-0.8c0.5-0.3,1-0.5,1.4-0.8c0.5-0.3,1-0.6,1.5-0.9   c0.5-0.3,0.9-0.5,1.3-0.8c0.5-0.3,1-0.6,1.5-1c0.4-0.3,0.8-0.6,1.2-0.8c0.5-0.4,1-0.7,1.5-1.1c0.4-0.3,0.7-0.5,1.1-0.8   c0.5-0.4,1.1-0.8,1.6-1.2c0.3-0.2,0.6-0.5,0.9-0.7c0.6-0.5,1.1-0.9,1.7-1.4c0.1-0.1,0.2-0.2,0.3-0.3c3-2.7,5.8-5.6,8.3-8.7   c0.1-0.1,0.2-0.3,0.3-0.4c0.5-0.7,1.1-1.4,1.6-2c0.1-0.2,0.3-0.4,0.4-0.6c0.5-0.7,1-1.3,1.4-2c0.2-0.2,0.3-0.5,0.5-0.7   c0.4-0.7,0.9-1.4,1.3-2c0.2-0.3,0.3-0.5,0.5-0.8c0.4-0.7,0.8-1.4,1.2-2.1c0.2-0.3,0.3-0.5,0.5-0.8c0.4-0.7,0.7-1.4,1.1-2.1   c0.1-0.3,0.3-0.6,0.4-0.9c0.3-0.7,0.7-1.4,1-2.1c0.1-0.3,0.3-0.6,0.4-0.9c0.3-0.7,0.6-1.4,0.9-2.2c0.1-0.3,0.2-0.6,0.4-1   c0.3-0.7,0.5-1.5,0.8-2.2c0.1-0.3,0.2-0.7,0.3-1c0.2-0.7,0.5-1.5,0.7-2.2c0.1-0.4,0.2-0.7,0.3-1.1c0.2-0.7,0.4-1.5,0.6-2.2   c0.1-0.4,0.2-0.8,0.3-1.2c0.2-0.7,0.3-1.4,0.5-2.2c0.1-0.4,0.1-0.9,0.2-1.3c0.1-0.7,0.2-1.4,0.3-2.1c0-0.1,0-0.1,0-0.2h214.9   c9.9,0,17.9,8,17.9,17.9v8.1l-77,77L354,183.2c-2.7-2.7-7.2-2.7-9.9,0l-90.9,90.9l-37.9-37.9c-2.7-2.7-7.2-2.7-9.9,0l-53.9,53.9   l-35.4-28.1c-2.6-2.1-6.4-2-8.9,0.2l-56.9,49.2V128.9C50.4,119,58.4,110.9,68.3,110.9z M281.4,470.7h-50.7l8.9-59.3h32.9   L281.4,470.7z M461.6,379.4c0,9.9-8,17.9-17.9,17.9H278.5h-44.9H68.3c-9.9,0-17.9-8-17.9-17.9v-49.7l61.7-53.3l35.8,28.4   c2.8,2.2,6.8,2,9.3-0.5l53.3-53.3l37.9,37.9c2.7,2.7,7.2,2.7,9.9,0l90.9-90.9l30.7,30.7c1.3,1.3,3.1,2,4.9,2s3.6-0.7,4.9-2l72-72   V379.4z" />

      <path d="M130.4,127.6c6.5,4.6,13.9,7.5,22,8.4v6.6c0,2.6,2.1,4.6,4.7,4.6c2.6,0,4.6-2,4.6-4.6v-6.4   c13.6-1.3,22.8-9.1,22.8-20.9c0-11.5-7-18-23.2-22.1V72.7c3.6,0.9,7.3,2.5,11,4.7c1.1,0.6,2.1,1,3.2,1c3.3,0,6-2.6,6-5.9   c0-2.6-1.5-4.2-3.2-5.1c-4.9-3.1-10.3-5.1-16.6-5.9v-2.4c0-2.6-2-4.6-4.6-4.6c-2.6,0-4.7,2-4.7,4.6v2.2c-13.4,1.1-22.5,9-22.5,20.5   c0,12.1,7.3,18,22.9,22.1v21.1c-5.9-1.1-10.8-3.5-15.8-7.2c-1-0.7-2.2-1.2-3.5-1.2c-3.3,0-5.9,2.6-5.9,5.9   C127.5,124.7,128.6,126.4,130.4,127.6z M161.2,105.9c8.2,2.6,10.6,5.5,10.6,10.2c0,5.1-3.7,8.6-10.6,9.3V105.9z M142.5,81   c0-4.7,3.4-8.4,10.3-9v19C144.5,88.3,142.5,85.5,142.5,81z" />
    </g>
  </svg>
);

export const FinanceAdvicesSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 512 512"
    id="Layer_1"
    version="1.1"
    xmlSpace="preserve"
    className="about-icon advices-icon"
  >
    <g>
      <path d="M337.8,305.7c25.9-23.5,40.4-57,39.9-91.9c-0.5-31.7-13.2-61.6-35.8-84.2c-22.6-22.6-52.5-35.3-84.2-35.7   c-32.9-0.4-63.8,12-87.2,35c-23.4,23.1-36.2,53.8-36.2,86.6c0,34.7,14.9,67.9,40.9,91c18,16,29,38.8,30.8,63.3h-11.2   c-3.9,0-7,3.1-7,7v24.1v31.8v24.1c0,3.9,3.1,7,7,7h19.1c3.3,17.7,18.9,31.2,37.5,31.2h9.3c18.7,0,34.2-13.5,37.5-31.2h19.1   c3.9,0,7-3.1,7-7v-24.1v-31.8v-24.1c0-3.9-3.1-7-7-7H306C307.9,345.6,319.2,322.5,337.8,305.7z M223,425.7h-21.3v-17.8H223V425.7z    M260.7,480.9h-9.3c-10.9,0-20.1-7.2-23.1-17.2h55.6C280.8,473.7,271.6,480.9,260.7,480.9z M291.8,449.8h-71.7h-18.4v-10.1H230   c3.9,0,7-3.1,7-7v-8.9h38v8.9c0,3.9,3.1,7,7,7h28.3v10.1H291.8z M310.3,425.7H289v-17.8h21.3V425.7z M310.3,393.9H282   c-3.9,0-7,3.1-7,7v8.9h-38v-8.9c0-3.9-3.1-7-7-7h-28.3v-10.1h108.5V393.9z M328.4,295.3c-21.5,19.5-34.5,46.3-36.4,74.5h-72   c-1.8-28.5-14.5-55-35.5-73.7c-23-20.4-36.2-49.8-36.2-80.5c0-29,11.4-56.3,32.1-76.7c20.7-20.4,48.1-31.4,77.2-31   c57.7,0.8,105.3,48.4,106.1,106.1C364.1,244.9,351.3,274.5,328.4,295.3z" />

      <path d="M265.4,218.2v-36.8c6.5,1.5,13,4.4,19.7,8.4c1.9,1.2,3.8,1.7,5.8,1.7c5.9,0,10.7-4.6,10.7-10.6   c0-4.6-2.7-7.5-5.8-9.2c-8.8-5.6-18.4-9.2-29.7-10.5V157c0-4.6-3.7-8.2-8.3-8.2c-4.6,0-8.4,3.6-8.4,8.2v4   c-24,1.9-40.3,16.1-40.3,36.6c0,8.8,2.2,15.7,6.6,21.4c6.5,8.3,17.8,13.8,34.5,18.1V275c-10.5-1.9-19.4-6.3-28.4-12.8   c-1.7-1.3-4-2.1-6.3-2.1c-5.9,0-10.5,4.6-10.5,10.5c0,4,1.9,7.1,5.2,9.2c11.7,8.2,24.9,13.4,39.3,15v11.9c0,4.6,3.8,8.2,8.4,8.2   c4.6,0,8.3-3.6,8.3-8.2v-11.5c24.3-2.3,40.8-16.3,40.8-37.4C307,237.2,294.5,225.5,265.4,218.2z M250.2,214.2c-3-1-5.5-2-7.7-3   c0,0,0,0,0,0c-8.4-4-10.7-8.5-10.7-14.9c0-8.4,6.1-14.9,18.4-16.1V214.2z M265.4,275.7v-34.9c14.8,4.6,19,9.8,19,18.2   C284.4,268.3,277.7,274.4,265.4,275.7z" />

      <path d="M54.5,224.8c-3.9,0-7,3.1-7,7s3.1,7,7,7H82c3.9,0,7-3.1,7-7s-3.1-7-7-7H54.5z" />

      <path d="M114,82.6c-2.7-2.7-7.2-2.7-9.9,0c-2.7,2.7-2.7,7.2,0,9.9l19.4,19.4c1.4,1.4,3.2,2.1,4.9,2.1s3.6-0.7,4.9-2.1   c2.7-2.7,2.7-7.2,0-9.9L114,82.6z" />

      <path d="M256.7,51.6V24.1c0-3.9-3.1-7-7-7s-7,3.1-7,7v27.5c0,3.9,3.1,7,7,7S256.7,55.4,256.7,51.6z" />

      <path d="M399,83.6c2.7-2.7,2.7-7.2,0-9.9c-2.7-2.7-7.2-2.7-9.9,0l-19.4,19.4c-2.7,2.7-2.7,7.2,0,9.9   c1.4,1.4,3.2,2.1,4.9,2.1s3.6-0.7,4.9-2.1L399,83.6z" />

      <path d="M430,212.3c-3.9,0-7,3.1-7,7s3.1,7,7,7h27.5c3.9,0,7-3.1,7-7s-3.1-7-7-7H430z" />
    </g>
  </svg>
);

export const RobotSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    className="about-icon robot-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 11C6.94772 11 6.5 11.4477 6.5 12C6.5 12.5523 6.94772 13 7.5 13C8.05228 13 8.5 12.5523 8.5 12C8.5 11.4477 8.05228 11 7.5 11ZM5.5 12C5.5 10.8954 6.39543 10 7.5 10C8.60457 10 9.5 10.8954 9.5 12C9.5 13.1046 8.60457 14 7.5 14C6.39543 14 5.5 13.1046 5.5 12Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 11C15.9477 11 15.5 11.4477 15.5 12C15.5 12.5523 15.9477 13 16.5 13C17.0523 13 17.5 12.5523 17.5 12C17.5 11.4477 17.0523 11 16.5 11ZM14.5 12C14.5 10.8954 15.3954 10 16.5 10C17.6046 10 18.5 10.8954 18.5 12C18.5 13.1046 17.6046 14 16.5 14C15.3954 14 14.5 13.1046 14.5 12Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 15.5C10.2761 15.5 10.5 15.7239 10.5 16L10.5003 16.0027C10.5003 16.0027 10.5014 16.0073 10.5034 16.0122C10.5074 16.022 10.5171 16.0405 10.5389 16.0663C10.5845 16.1202 10.6701 16.1902 10.8094 16.2599C11.0883 16.3993 11.5085 16.5 12 16.5C12.4915 16.5 12.9117 16.3993 13.1906 16.2599C13.3299 16.1902 13.4155 16.1202 13.4611 16.0663C13.4829 16.0405 13.4926 16.022 13.4966 16.0122C13.4986 16.0073 13.4997 16.0027 13.4997 16.0027L13.5 16C13.5 15.7239 13.7239 15.5 14 15.5C14.2761 15.5 14.5 15.7239 14.5 16C14.5 16.5676 14.0529 16.9468 13.6378 17.1543C13.1928 17.3768 12.6131 17.5 12 17.5C11.3869 17.5 10.8072 17.3768 10.3622 17.1543C9.9471 16.9468 9.5 16.5676 9.5 16C9.5 15.7239 9.72386 15.5 10 15.5Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16 5.5V7.5H8V5.5C8 5.22386 7.77614 5 7.5 5C7.22386 5 7 5.22386 7 5.5V7.5H6C4.61929 7.5 3.5 8.61929 3.5 10V17C3.5 18.3807 4.61929 19.5 6 19.5H18C19.3807 19.5 20.5 18.3807 20.5 17V10C20.5 8.61929 19.3807 7.5 18 7.5H17V5.5C17 5.22386 16.7761 5 16.5 5C16.2239 5 16 5.22386 16 5.5ZM6 8.5C5.17157 8.5 4.5 9.17157 4.5 10V17C4.5 17.8284 5.17157 18.5 6 18.5H18C18.8284 18.5 19.5 17.8284 19.5 17V10C19.5 9.17157 18.8284 8.5 18 8.5H6Z"
    />
  </svg>
);

export const AnalysesSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 512 512"
    id="Layer_1"
    version="1.1"
    xmlSpace="preserve"
    className="about-icon analyses-icon"
  >
    <g>
      <path
        className="st0"
        d="M93.5,329.2c-38.7,0-67.9,14.3-67.9,33.3v52.6c0,19,29.2,33.3,67.9,33.3s67.9-14.3,67.9-33.3v-52.6   C161.4,343.6,132.2,329.2,93.5,329.2z M39.6,379.1c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v17.2   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4V379.1z M93.5,343.2c32.9,0,53.9,11.4,53.9,19.3v7.4   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-7.4C39.6,354.7,60.6,343.2,93.5,343.2z M93.5,434.5   c-32.9,0-53.9-11.4-53.9-19.3v-9.8c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v9.8C147.4,423,126.4,434.5,93.5,434.5z"
      />

      <path
        className="st0"
        d="M256,276.6c-38.7,0-67.9,14.3-67.9,33.3v105.2c0,19,29.2,33.3,67.9,33.3s67.9-14.3,67.9-33.3V309.9   C323.9,290.9,294.7,276.6,256,276.6z M309.9,369.9c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V369.9z M309.9,343.6c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V343.6z M202.1,379.1c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v17.2   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4V379.1z M256,290.6c32.9,0,53.9,11.4,53.9,19.3v7.4   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-7.4C202.1,302.1,223.1,290.6,256,290.6z M256,434.5   c-32.9,0-53.9-11.4-53.9-19.3v-9.8c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v9.8C309.9,423,288.9,434.5,256,434.5z"
      />

      <path
        className="st0"
        d="M418.5,224c-38.7,0-67.9,14.3-67.9,33.3v157.8c0,19,29.2,33.3,67.9,33.3s67.9-14.3,67.9-33.3V257.3   C486.4,238.3,457.2,224,418.5,224z M472.4,369.9c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V369.9z M472.4,343.6c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V343.6z M472.4,317.3c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V317.3z M472.4,291c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-17.2   c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3V291z M364.6,379.1c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v17.2   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4V379.1z M418.5,238c32.9,0,53.9,11.4,53.9,19.3v7.4   c-7.7,8.2-27.7,15.4-53.9,15.4s-46.1-7.2-53.9-15.4v-7.4C364.6,249.5,385.6,238,418.5,238z M418.5,434.5   c-32.9,0-53.9-11.4-53.9-19.3v-9.8c11.4,8.1,31.1,13.3,53.9,13.3s42.5-5.2,53.9-13.3v9.8C472.4,423,451.4,434.5,418.5,434.5z"
      />

      <path
        className="st0"
        d="M93.5,283.1c14.2,0,25.8-11.6,25.8-25.8c0-0.7,0-1.4-0.1-2l115.9-42.8c4.7,6.4,12.3,10.6,20.9,10.6   c14.2,0,25.8-11.6,25.8-25.8c0-2.8-0.4-5.4-1.2-7.9l121.1-80.5c4.5,3.9,10.4,6.2,16.8,6.2c14.2,0,25.8-11.6,25.8-25.8   s-11.6-25.8-25.8-25.8s-25.8,11.6-25.8,25.8c0,2.8,0.4,5.4,1.2,7.9l-121.1,80.5c-4.5-3.9-10.4-6.2-16.8-6.2   c-14.2,0-25.8,11.6-25.8,25.8c0,0.7,0,1.4,0.1,2l-115.9,42.8c-4.7-6.4-12.3-10.6-20.9-10.6c-14.2,0-25.8,11.6-25.8,25.8   S79.3,283.1,93.5,283.1z M418.5,77.5c6.5,0,11.8,5.3,11.8,11.8s-5.3,11.8-11.8,11.8s-11.8-5.3-11.8-11.8S412,77.5,418.5,77.5z    M256,185.6c6.5,0,11.8,5.3,11.8,11.8s-5.3,11.8-11.8,11.8c-5,0-9.3-3.2-11-7.6c0,0,0-0.1,0-0.1c0,0,0,0,0-0.1   c-0.5-1.3-0.7-2.6-0.7-4C244.2,190.9,249.5,185.6,256,185.6z M93.5,245.5c6.5,0,11.8,5.3,11.8,11.8s-5.3,11.8-11.8,11.8   s-11.8-5.3-11.8-11.8S87,245.5,93.5,245.5z"
      />
    </g>
  </svg>
);

export const ControlPanelSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="800px"
    height="800px"
    viewBox="0 0 512 512"
    id="Layer_1"
    version="1.1"
    xmlSpace="preserve"
    className="about-icon controlPanel-icon"
  >
    <g>
      <path
        className="st0"
        d="M263.6,245v-29.9c5.3,1.2,10.6,3.6,16,6.8c1.6,0.9,3.1,1.4,4.7,1.4c4.8,0,8.7-3.7,8.7-8.6   c0-3.7-2.2-6.1-4.7-7.5c-7.2-4.5-14.9-7.5-24.1-8.6v-3.4c0-3.7-3-6.7-6.7-6.7c-3.7,0-6.8,3-6.8,6.7v3.3   c-19.4,1.6-32.7,13.1-32.7,29.7c0,17.6,10.6,26.1,33.3,32V291c-8.6-1.6-15.7-5.1-23-10.4c-1.4-1.1-3.3-1.7-5.1-1.7   c-4.8,0-8.6,3.7-8.6,8.6c0,3.3,1.6,5.8,4.2,7.5c9.5,6.7,20.2,10.9,31.9,12.1v9.6c0,3.7,3.1,6.7,6.8,6.7c3.7,0,6.7-3,6.7-6.7v-9.3   c19.8-1.9,33.1-13.2,33.1-30.3C297.4,260.4,287.3,250.9,263.6,245z M251.3,241.7c-12-3.9-14.9-7.9-14.9-14.5   c0-6.8,5-12.1,14.9-13.1V241.7z M263.6,291.6v-28.3c12,3.7,15.4,7.9,15.4,14.8C279,285.6,273.6,290.5,263.6,291.6z"
      />

      <path
        className="st0"
        d="M256,152.4c-14.8,0-29.2,3.1-42.6,9.1c-37.1,16.7-61,53.8-61,94.5c0,1.1,0,2.3,0.1,3.4c0.9,27,12,52.2,31.4,71   c19.4,18.9,45.1,29.2,72.1,29.2c57.1,0,103.6-46.5,103.6-103.6S313.1,152.4,256,152.4z M256,345.6c-48.7,0-88-38.1-89.6-86.7   c0-1,0-1.9,0-2.9c0-35.2,20.7-67.2,52.8-81.7c11.6-5.2,24-7.9,36.8-7.9c49.4,0,89.6,40.2,89.6,89.6S305.4,345.6,256,345.6z"
      />

      <path
        className="st0"
        d="M256,114.7c-20.2,0-39.8,4.2-58.1,12.4c-50.6,22.8-83.2,73.4-83.2,128.9c0,1.7,0,3.2,0.1,4.6   c1.2,36.8,16.4,71.2,42.9,96.8c26.5,25.7,61.5,39.9,98.4,39.9c77.9,0,141.3-63.4,141.3-141.3S333.9,114.7,256,114.7z M256,383.3   c-69.1,0-125-54.1-127.3-123.2c0-1.3-0.1-2.6-0.1-4.1c0-50,29.4-95.5,75-116.1c16.5-7.4,34.1-11.2,52.3-11.2   c70.2,0,127.3,57.1,127.3,127.3S326.2,383.3,256,383.3z"
      />

      <path
        className="st0"
        d="M208.5,105.8c3.9,0,7-3.1,7-7V61.2c8.6-2.9,14.8-11.1,14.8-20.7c0-12-9.8-21.8-21.8-21.8s-21.8,9.8-21.8,21.8   c0,9.6,6.2,17.8,14.8,20.7v37.7C201.5,102.7,204.6,105.8,208.5,105.8z M208.5,32.7c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8   s-7.8-3.5-7.8-7.8S204.2,32.7,208.5,32.7z"
      />

      <path
        className="st0"
        d="M303.5,105.8c3.9,0,7-3.1,7-7V61.2c8.6-2.9,14.8-11.1,14.8-20.7c0-12-9.8-21.8-21.8-21.8s-21.8,9.8-21.8,21.8   c0,9.6,6.2,17.8,14.8,20.7v37.7C296.5,102.7,299.6,105.8,303.5,105.8z M303.5,32.7c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8   s-7.8-3.5-7.8-7.8S299.2,32.7,303.5,32.7z"
      />

      <path
        className="st0"
        d="M215.5,450.8v-37.7c0-3.9-3.1-7-7-7s-7,3.1-7,7v37.7c-8.6,2.9-14.8,11.1-14.8,20.7c0,12,9.8,21.8,21.8,21.8   s21.8-9.8,21.8-21.8C230.3,461.9,224.1,453.7,215.5,450.8z M208.5,479.3c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8   S212.8,479.3,208.5,479.3z"
      />

      <path
        className="st0"
        d="M310.5,450.8v-37.7c0-3.9-3.1-7-7-7s-7,3.1-7,7v37.7c-8.6,2.9-14.8,11.1-14.8,20.7c0,12,9.8,21.8,21.8,21.8   s21.8-9.8,21.8-21.8C325.3,461.9,319.1,453.7,310.5,450.8z M303.5,479.3c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8   S307.8,479.3,303.5,479.3z"
      />

      <path
        className="st0"
        d="M107.5,183.4H91v-50c0-3.9-3.1-7-7-7H54.8c-2.9-8.6-11.1-14.8-20.7-14.8c-12,0-21.8,9.8-21.8,21.8   s9.8,21.8,21.8,21.8c9.6,0,17.8-6.2,20.7-14.8H77v50c0,3.9,3.1,7,7,7h23.5c3.9,0,7-3.1,7-7S111.4,183.4,107.5,183.4z M34.2,141.3   c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8S38.5,141.3,34.2,141.3z"
      />

      <path
        className="st0"
        d="M107.5,314.6H84c-3.9,0-7,3.1-7,7v50H54.8c-2.9-8.6-11.1-14.8-20.7-14.8c-12,0-21.8,9.8-21.8,21.8   s9.8,21.8,21.8,21.8c9.6,0,17.8-6.2,20.7-14.8H84c3.9,0,7-3.1,7-7v-50h16.5c3.9,0,7-3.1,7-7S111.4,314.6,107.5,314.6z M34.2,386.4   c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8S38.5,386.4,34.2,386.4z"
      />

      <path
        className="st0"
        d="M64.3,262.4H98c3.9,0,7-3.1,7-7s-3.1-7-7-7H64.3c-2.9-8.6-11.1-14.8-20.7-14.8c-12,0-21.8,9.8-21.8,21.8   s9.8,21.8,21.8,21.8C53.3,277.3,61.4,271,64.3,262.4z M35.8,255.4c0-4.3,3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8   S35.8,259.7,35.8,255.4z"
      />

      <path
        className="st0"
        d="M477.8,111.6c-9.6,0-17.8,6.2-20.7,14.8H428c-3.9,0-7,3.1-7,7v50h-16.5c-3.9,0-7,3.1-7,7s3.1,7,7,7H428   c3.9,0,7-3.1,7-7v-50h22.2c2.9,8.6,11.1,14.8,20.7,14.8c12,0,21.8-9.8,21.8-21.8S489.9,111.6,477.8,111.6z M477.8,141.3   c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8S482.2,141.3,477.8,141.3z"
      />

      <path
        className="st0"
        d="M477.8,356.8c-9.6,0-17.8,6.2-20.7,14.8H435v-50c0-3.9-3.1-7-7-7h-23.5c-3.9,0-7,3.1-7,7s3.1,7,7,7H421v50   c0,3.9,3.1,7,7,7h29.2c2.9,8.6,11.1,14.8,20.7,14.8c12,0,21.8-9.8,21.8-21.8S489.9,356.8,477.8,356.8z M477.8,386.4   c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8s7.8,3.5,7.8,7.8S482.2,386.4,477.8,386.4z"
      />

      <path
        className="st0"
        d="M447.7,262.4c2.9,8.6,11.1,14.8,20.7,14.8c12,0,21.8-9.8,21.8-21.8s-9.8-21.8-21.8-21.8   c-9.6,0-17.8,6.2-20.7,14.8H414c-3.9,0-7,3.1-7,7s3.1,7,7,7H447.7z M468.3,247.6c4.3,0,7.8,3.5,7.8,7.8s-3.5,7.8-7.8,7.8   s-7.8-3.5-7.8-7.8S464,247.6,468.3,247.6z"
      />
    </g>
  </svg>
);

export const AboutMoneyBgSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    className="moneyBg-icon"
  >
    <g filter="url(#filter0_ii_366_29665)">
      <g clipPath="url(#clip0_366_29665)">
        <rect
          width="72"
          height="72.0001"
          rx="36"
          fill="url(#paint0_radial_366_29665)"
        />
        <rect
          width="72"
          height="72.0001"
          rx="36"
          fill="url(#paint1_linear_366_29665)"
        />
        <g opacity="0.5" filter="url(#filter1_f_366_29665)">
          <rect
            x="17.9998"
            y="-17.9995"
            width="36"
            height="36"
            rx="18"
            fill="white"
          />
        </g>
        <g opacity="0.3" filter="url(#filter2_f_366_29665)">
          <rect
            x="14.9998"
            y="45.0005"
            width="42"
            height="42"
            rx="21"
            fill="#420FA9"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="filter0_ii_366_29665"
        x="0"
        y="-3.375"
        width="72"
        height="75.375"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-3.375" />
        <feGaussianBlur stdDeviation="3.375" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.898039 0 0 0 0 0.882353 0 0 0 0 0.992157 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_366_29665"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius="1.125"
          operator="erode"
          in="SourceAlpha"
          result="effect2_innerShadow_366_29665"
        />
        <feOffset />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.898039 0 0 0 0 0.882353 0 0 0 0 0.992157 0 0 0 0.64 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_innerShadow_366_29665"
          result="effect2_innerShadow_366_29665"
        />
      </filter>
      <filter
        id="filter1_f_366_29665"
        x="-9.00026"
        y="-44.9995"
        width="90"
        height="90"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="13.5"
          result="effect1_foregroundBlur_366_29665"
        />
      </filter>
      <filter
        id="filter2_f_366_29665"
        x="-21.0003"
        y="9.00047"
        width="114"
        height="114"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="18"
          result="effect1_foregroundBlur_366_29665"
        />
      </filter>
      <radialGradient
        id="paint0_radial_366_29665"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(36 36) rotate(90) scale(78 300.707)"
      >
        <stop stopColor="#6742FB" />
        <stop offset="0.844832" stopColor="#B7A7F7" />
      </radialGradient>
      <linearGradient
        id="paint1_linear_366_29665"
        x1="21.0423"
        y1="38.25"
        x2="40.2961"
        y2="74.9485"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#6742FB" stopOpacity="0.8" />
        <stop offset="0.844832" stopColor="#B7A7F7" />
      </linearGradient>
      <clipPath id="clip0_366_29665">
        <rect width="72" height="72.0001" rx="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

interface Props {
  onClick?: () => void;
}
export const CloseIcon = ({ onClick }: Props) => (
  <svg
    onClick={() => onClick?.()}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="close-icon"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6 18L18 6M6 6l12 12"
    />
  </svg>
);

export const CloseBarSvg = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="closeBar-icon"
  >
    <path
      d="M2 5.99519C2 5.44556 2.44556 5 2.99519 5H11.0048C11.5544 5 12 5.44556 12 5.99519C12 6.54482 11.5544 6.99039 11.0048 6.99039H2.99519C2.44556 6.99039 2 6.54482 2 5.99519Z"
      fill="black"
    />
    <path
      d="M2 11.9998C2 11.4501 2.44556 11.0046 2.99519 11.0046H21.0048C21.5544 11.0046 22 11.4501 22 11.9998C22 12.5494 21.5544 12.9949 21.0048 12.9949H2.99519C2.44556 12.9949 2 12.5494 2 11.9998Z"
      fill="black"
    />
    <path
      d="M2.99519 17.0096C2.44556 17.0096 2 17.4552 2 18.0048C2 18.5544 2.44556 19 2.99519 19H15.0048C15.5544 19 16 18.5544 16 18.0048C16 17.4552 15.5544 17.0096 15.0048 17.0096H2.99519Z"
      fill="black"
    />
  </svg>
);

export const OpenBarSvg = () => (
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="openBar-icon"
  >
    <path
      d="M22 18.0048C22 18.5544 21.5544 19 21.0048 19H12.9952C12.4456 19 12 18.5544 12 18.0048C12 17.4552 12.4456 17.0096 12.9952 17.0096H21.0048C21.5544 17.0096 22 17.4552 22 18.0048Z"
      fill="black"
    />
    <path
      d="M22 12.0002C22 12.5499 21.5544 12.9954 21.0048 12.9954H2.99519C2.44556 12.9954 2 12.5499 2 12.0002C2 11.4506 2.44556 11.0051 2.99519 11.0051H21.0048C21.5544 11.0051 22 11.4506 22 12.0002Z"
      fill="black"
    />
    <path
      d="M21.0048 6.99039C21.5544 6.99039 22 6.54482 22 5.99519C22 5.44556 21.5544 5 21.0048 5H8.99519C8.44556 5 8 5.44556 8 5.99519C8 6.54482 8.44556 6.99039 8.99519 6.99039H21.0048Z"
      fill="black"
    />
  </svg>
);

export const MenuIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.933 16.933"
    id="menu"
    width="24"
    height="24"
    className="menu-icon"
  >
    <path d="M12.271 1.323H1.984c-1.1-.042-1.1 1.63 0 1.588H12.23c1.08.042 1.122-1.588.042-1.588zM1.984 7.673c-1.058 0-1.058 1.587 0 1.587h5.8c1.08 0 1.08-1.587 0-1.587zm0 6.35c-1.058 0-1.058 1.587 0 1.587h12.997c1.058 0 1.058-1.587 0-1.587z"></path>
  </svg>
);

export const FacebookSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="#000000"
    width="800px"
    height="800px"
    viewBox="0 0 32 32"
    className="facebook-icon"
  >
    <path d="M21.95 5.005l-3.306-.004c-3.206 0-5.277 2.124-5.277 5.415v2.495H10.05v4.515h3.317l-.004 9.575h4.641l.004-9.575h3.806l-.003-4.514h-3.803v-2.117c0-1.018.241-1.533 1.566-1.533l2.366-.001.01-4.256z" />
  </svg>
);

export const InstagramSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 24 24"
    fill="none"
    className="instagram-icon"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 18C15.3137 18 18 15.3137 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 15.3137 8.68629 18 12 18ZM12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16Z"
    />
    <path d="M18 5C17.4477 5 17 5.44772 17 6C17 6.55228 17.4477 7 18 7C18.5523 7 19 6.55228 19 6C19 5.44772 18.5523 5 18 5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.65396 4.27606C1 5.55953 1 7.23969 1 10.6V13.4C1 16.7603 1 18.4405 1.65396 19.7239C2.2292 20.8529 3.14708 21.7708 4.27606 22.346C5.55953 23 7.23969 23 10.6 23H13.4C16.7603 23 18.4405 23 19.7239 22.346C20.8529 21.7708 21.7708 20.8529 22.346 19.7239C23 18.4405 23 16.7603 23 13.4V10.6C23 7.23969 23 5.55953 22.346 4.27606C21.7708 3.14708 20.8529 2.2292 19.7239 1.65396C18.4405 1 16.7603 1 13.4 1H10.6C7.23969 1 5.55953 1 4.27606 1.65396C3.14708 2.2292 2.2292 3.14708 1.65396 4.27606ZM13.4 3H10.6C8.88684 3 7.72225 3.00156 6.82208 3.0751C5.94524 3.14674 5.49684 3.27659 5.18404 3.43597C4.43139 3.81947 3.81947 4.43139 3.43597 5.18404C3.27659 5.49684 3.14674 5.94524 3.0751 6.82208C3.00156 7.72225 3 8.88684 3 10.6V13.4C3 15.1132 3.00156 16.2777 3.0751 17.1779C3.14674 18.0548 3.27659 18.5032 3.43597 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.49684 20.7234 5.94524 20.8533 6.82208 20.9249C7.72225 20.9984 8.88684 21 10.6 21H13.4C15.1132 21 16.2777 20.9984 17.1779 20.9249C18.0548 20.8533 18.5032 20.7234 18.816 20.564C19.5686 20.1805 20.1805 19.5686 20.564 18.816C20.7234 18.5032 20.8533 18.0548 20.9249 17.1779C20.9984 16.2777 21 15.1132 21 13.4V10.6C21 8.88684 20.9984 7.72225 20.9249 6.82208C20.8533 5.94524 20.7234 5.49684 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43597C18.5032 3.27659 18.0548 3.14674 17.1779 3.0751C16.2777 3.00156 15.1132 3 13.4 3Z"
    />
  </svg>
);

export const TelegramFilledSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="800px"
    height="800px"
    viewBox="0 0 48 48"
    fill="none"
    className="telegram-icon"
  >
    <path d="M41.4193 7.30899C41.4193 7.30899 45.3046 5.79399 44.9808 9.47328C44.8729 10.9883 43.9016 16.2908 43.1461 22.0262L40.5559 39.0159C40.5559 39.0159 40.3401 41.5048 38.3974 41.9377C36.4547 42.3705 33.5408 40.4227 33.0011 39.9898C32.5694 39.6652 24.9068 34.7955 22.2086 32.4148C21.4531 31.7655 20.5897 30.4669 22.3165 28.9519L33.6487 18.1305C34.9438 16.8319 36.2389 13.8019 30.8426 17.4812L15.7331 27.7616C15.7331 27.7616 14.0063 28.8437 10.7686 27.8698L3.75342 25.7055C3.75342 25.7055 1.16321 24.0823 5.58815 22.459C16.3807 17.3729 29.6555 12.1786 41.4193 7.30899Z" />
  </svg>
);

export const TelegramSvg = ({ color = "#4b38b3" }: { color?: string }) => (
  <svg
    width="28"
    height="23"
    viewBox="0 0 28 23"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className="telegram-icon"
  >
    <path
      d="M0.414203 10.565C3.21978 9.01958 6.35158 7.72978 9.27778 6.43338C14.312 4.30999 19.3662 2.22338 24.4714 0.280785C25.4647 -0.0502153 27.2494 -0.373915 27.4244 1.09808C27.3286 3.18168 26.9344 5.25309 26.664 7.32448C25.9777 11.8797 25.1845 16.4193 24.411 20.9595C24.1445 22.4718 22.25 23.2547 21.0378 22.2869C18.1246 20.3191 15.189 18.3705 12.313 16.3571C11.3709 15.3998 12.2445 14.0251 13.0859 13.3415C15.4853 10.9769 18.0299 8.96789 20.3039 6.48108C20.9173 4.99978 19.1049 6.24818 18.5071 6.63068C15.2223 8.89429 12.0179 11.2961 8.55468 13.2855C6.78568 14.2593 4.72388 13.4271 2.95568 12.8837C1.37026 12.2273 -0.952956 11.566 0.414044 10.5651L0.414203 10.565Z"
      fill={color}
    />
  </svg>
);

export const PhoneSVG = ({ color = "#4b38b3" }: { color?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
    className="phone-icon"
  >
    <path
      d="M19.231 15.2617L16.691 14.9717C16.081 14.9017 15.481 15.1117 15.051 15.5417L13.211 17.3817C10.381 15.9417 8.06102 13.6317 6.62102 10.7917L8.47102 8.94172C8.90102 8.51172 9.11102 7.91172 9.04102 7.30172L8.75102 4.78172C8.63102 3.77172 7.78102 3.01172 6.76102 3.01172H5.03102C3.90102 3.01172 2.96102 3.95172 3.03102 5.08172C3.56102 13.6217 10.391 20.4417 18.921 20.9717C20.051 21.0417 20.991 20.1017 20.991 18.9717V17.2417C21.001 16.2317 20.241 15.3817 19.231 15.2617Z"
      fill={color}
    />
  </svg>
);
export const PhoneFilledSvg = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className="phone-icon"
  >
    <path d="M19.231 15.2617L16.691 14.9717C16.081 14.9017 15.481 15.1117 15.051 15.5417L13.211 17.3817C10.381 15.9417 8.06102 13.6317 6.62102 10.7917L8.47102 8.94172C8.90102 8.51172 9.11102 7.91172 9.04102 7.30172L8.75102 4.78172C8.63102 3.77172 7.78102 3.01172 6.76102 3.01172H5.03102C3.90102 3.01172 2.96102 3.95172 3.03102 5.08172C3.56102 13.6217 10.391 20.4417 18.921 20.9717C20.051 21.0417 20.991 20.1017 20.991 18.9717V17.2417C21.001 16.2317 20.241 15.3817 19.231 15.2617Z" />
  </svg>
);
